import { buildAuthHeaders, getWorkerUrl } from '@agentic-flow-studio/shared/lib/trpc';
import { DefaultChatTransport } from 'ai';
import { useMemo } from 'react';

export function useJobPlanChatTransport(serviceDate?: string) {
  return useMemo(
    () =>
      new DefaultChatTransport({
        api: `${getWorkerUrl()}/job-plan-chat`,
        headers: buildAuthHeaders,
        body: serviceDate ? { serviceDate } : undefined,
      }),
    [serviceDate]
  );
}
